import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { cancelarAlert } from 'app/services/alerts';
import { FormikProvider, useFormik } from 'formik';
import React, { useEffect } from 'react';
import MailForm from './MailForm';
import MailSchema from './MailSchema';

const MailModal = ({
  sendEmail,
  open,
  handleCloseModal,
  templateMail,
  email = [''],
  isMultipleEmails,
  setEmail = () => {},
}) => {
  const initialValues = {
    emails: isMultipleEmails ? email : [email],
    assunto: '',
  };

  const handleClose = () => {
    if (formik.dirty) {
      cancelarAlert({
        confirmar: close,
      });
    } else {
      close();
    }
  };

  const close = () => {
    setEmail('');
    formik.resetForm(initialValues);
    handleCloseModal();
  };

  const handleSubmit = async () => {
    const res = await sendEmail(formik.values.emails, formik.values.assunto);

    if (res) {
      close();
    }
  };

  const formik = useFormik({
    validationSchema: MailSchema,
    initialValues,
    onSubmit: handleSubmit,
    validateOnChange: true,
    validateOnBlur: true,
  });

  useEffect(() => {
    if (email && isMultipleEmails) {
      formik.resetForm(initialValues);
    }
    // Efeito reativo apenas ao gatilho acima; incluir as demais reiniciaria o formulário durante a edição.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email, isMultipleEmails]);

  return (
    <SimpleDialog open={open} onClose={handleClose} innerScroll>
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          fullScreen
          header={{
            title: 'Enviar e-mail',
            toolbar: (
              <>
                <CancelButton onClick={handleClose}>Cancelar</CancelButton>
                <SaveButton color="buttonSave" type="submit">
                  Enviar
                </SaveButton>
              </>
            ),
          }}
          content={<MailForm templateMail={templateMail} />}
        />
      </FormikProvider>
    </SimpleDialog>
  );
};

export default MailModal;
